import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

const CTASection = () => {
  // Language state jo Header ke saath sync rahegi
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  // Storage change ko listen karne ke liye (taaki language turant switch ho)
  useEffect(() => {
    const handleStorageChange = () => {
      setLang(localStorage.getItem("lang") || "en");
    };
    
    // Custom event listen karna padega kyunki same tab pe storage event trigger nahi hota
    window.addEventListener('storage', handleStorageChange);
    const interval = setInterval(handleStorageChange, 500); // Quick check interval

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  // --- TRANSLATION DATA ---
  const content = {
    en: {
      badge: "Take the Next Step",
      title: "Ready to Elevate Your",
      highlight: "Business Strategy",
      suffix: "with Rigors?",
      btnText: "Get Started Now"
    },
    zh: {
      badge: "迈向下一步",
      title: "准备好提升您的",
      highlight: "业务战略",
      suffix: "与 Rigors 合作吗？",
      btnText: "立即开始"
    }
  };

  const current = content[lang];

  return (
    <section className="relative w-full h-[40vh] md:h-[50vh] flex items-center justify-center overflow-hidden">
      {/* Background Image - Corporate Office */}
      <div 
        className="absolute inset-0 bg-fixed bg-center bg-cover"
        style={{ 
          backgroundImage: `url('./CTA-FINAL.jpg')` 
        }}
      />
      
      {/* Dark Navy Overlay */}
      <div className="absolute inset-0 bg-[#0f172a]/55" />

      {/* Content Container */}
      <div className="container relative z-10 px-6 mx-auto md:px-12 max-w-7xl">
        
        <div className="flex flex-col items-center text-center justify-between gap-10 md:flex-row md:text-left">
          
          {/* Left Content */}
          <div className="w-full text-center md:text-left md:w-2/3">
            <span className="text-[#38bdf8] uppercase tracking-[0.25em] font-bold text-[11px] mb-3 block font-arial">
              {current.badge}
            </span>
            <h2 className="text-2xl font-normal leading-tight text-white md:text-4xl font-century">
              {current.title} <span className="italic font-bold text-white">{current.highlight}</span> {current.suffix}
            </h2>
          </div>

          {/* Right Button */}
          <div className="flex justify-end md:w-1/3">
           <Link to="/services">
            <button className="bg-white hover:bg-[#38bdf8] text-[#0f172a] hover:text-white font-bold px-10 py-4 rounded-full transition-all duration-300 shadow-xl active:scale-95  tracking-widest text-[13px] font-arial">
              {current.btnText}
            </button>
            </Link>
          </div>
          
        </div>
        
      </div>
    </section>
  );
};

export default CTASection;